import { getText } from 'shared/utils/Text';

import AlertDialog from './AlertDialog';

const GuaranteeAlertDialog = ({ ...props }) => (
  <AlertDialog title={getText('alert-guarantee-factor')} {...props} />
);

export default GuaranteeAlertDialog;
